import apiClient from '@u/apiClient'

export default {
  createChiftInvoicingConnexion(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.id}/partners/chift-invoicing/connexion`, {
          callback_url: payload.callback_url
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  disconnectChiftInvoicing(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`company/${payload.id}/partners/chift-invoicing`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteChiftInvoicingConnexion(_, payload) {
    return Promise.all([
      apiClient.delete(`company/${payload.id}/chift/connexion/${payload.connexion_id}`),
      apiClient.delete(`company/${payload.id}/partners/chift-invoicing`)
    ])
  }
}
